module.exports = "<main>\n    <router-outlet></router-outlet>\n</main>"


//////////////////
// WEBPACK FOOTER
// F:/node/angular/complejidadesFrontend/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = 4